import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import { addIntlProps } from 'utils/recompose';
import messages from './messages';

export default compose(
  injectIntl,
  addIntlProps({
    messages,
    propNames: [
      'clearFiltersButton',
      'cancelButton',
      'warningTitle',
      'warningMessage',
    ],
  }),
);
